export default "__VITE_ASSET__DXF1vGCG__"